// removed by extract-text-webpack-plugin
module.exports = {"active":"_10BxRs-EKZvj_DR8TJ3jOf"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/lots/styles.css
// module id = 1633
// module chunks = 0